<app-breadcrumb [breadcrumb]="breadcrumb"/>
<h2>Detalhes da unidade</h2>
<div class="card">
  <form [formGroup]="form">
    <div class="input-forms">
      <mat-form-field>
        <mat-label>CR/Unidade</mat-label>
        <input matInput placeholder="Digite aqui..." formControlName="code"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Nome</mat-label>
        <input matInput placeholder="Digite aqui..." formControlName="name"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Regional</mat-label>
        <input matInput placeholder="Digite aqui..." formControlName="region"/>
      </mat-form-field>
    </div>
    <div class="input-forms">
      <mat-form-field>
        <mat-label>Status</mat-label>
        <input
          matInput
          placeholder="Digite aqui..."
          [value]="form.controls.active ? 'Ativo' : 'Desativado'"
          disabled
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Cliente</mat-label>
        <input
          matInput
          placeholder="Digite aqui..."
          formControlName="customerName"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Nome curto</mat-label>
        <input
          matInput
          placeholder="Nome curto"
          formControlName="shortBranch"
        />
        <mat-icon matSuffix (click)="shortNameHandler()">refresh</mat-icon>
      </mat-form-field>

    </div>

    <div class="cards-data">
      <p>Usuários</p>

      <div class="inputs-card">
        <mat-form-field class="searchUsers">
          <mat-label>Procurar usuários</mat-label>
          <input
            type="text"
            placeholder="Procurar usuários por nome ou e-mail..."
            aria-label="Usuários"
            matInput
            [formControl]="searchUser"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @if (loadingUsers) {
              <mat-option disabled>Carregando...</mat-option>
            } @else if (!loadingUsers && isSearching && searchUser.value &&
            !usersList.length) {
              <mat-option disabled>Nenhum resultado encontrado</mat-option>
            }
            @for (option of usersList; track option.id) {

              <mat-option (click)="checkAddUser(option)">
                {{ option.name }} - {{ option.email }}
              </mat-option>

            }
          </mat-autocomplete>
        </mat-form-field>

        @for (user of form.controls.usersBranch.controls; track user.controls) {
          <div class="input-list border">
            <div>
              <p>
                {{ user.controls.userName.value }}
              </p>
              <p>
                {{ user.controls.userEmail.value }}
              </p>
            </div>

            <img
              src="assets/img/delete.png"
              alt="add"
              (click)="deleteUser(user.controls.userId.value!)"
            />
          </div>
        } @empty {
          <div class="empty">
            <p>Não existe usuários nesta unidade</p>
          </div>
        }
      </div>
    </div>

    <mat-divider></mat-divider>
    <h3>Pesquisa de satisfação</h3>

    <app-unit-poll-autocomplete
      [typePoll]="PollTypeEnum.Satisfaction"
      [form]="form.controls.pollId"
      [formSearch]="satisfactionSearchPoll"
      [polls]="pollsSatisfaction"
    />

    <app-unit-available-time-section
      [form]="form.controls.satisfactionAvailableShifts"
      [typePoll]="PollTypeEnum.Satisfaction"
    />

    <app-unit-devices-section
      [form]="form.controls.satisfactionDevices"
      [typePoll]="PollTypeEnum.Satisfaction"
    />

    <mat-divider></mat-divider>
    <h3>Pesquisa de reserva de pratos</h3>

    <app-unit-poll-autocomplete
      [typePoll]="PollTypeEnum.Reservation"
      [form]="form.controls.pollDishReservationId"
      [formSearch]="reservationSearchPoll"
      [polls]="pollsReservation"
    />

    <app-unit-available-time-section
      [form]="form.controls.reservationAvailableShifts"
      [typePoll]="PollTypeEnum.Reservation"
    />

    <app-unit-devices-section
      [form]="form.controls.reservationDevices"
      [typePoll]="PollTypeEnum.Reservation"
    />

    @if (canViewSuspiciousActivityConfig) {
      <h3>Bloqueio Progressivo por Atividade Suspeita</h3>

      <div formGroupName="suspiciousActivityConfig">
      <div class="suspicious-activity-block" formGroupName="level1">
        <div class="suspicious-activity-level-line">
          <mat-slide-toggle
            class="section-toggle"
            formControlName="active"
            aria-label="Ativar Nível 1 - Respostas consecutivas"
          ></mat-slide-toggle>
          <h4>Nível 1 - Respostas consecutivas</h4>
        </div>

        <div class="suspicious-activity-panel">
          <p class="suspicious-activity-helper">Bloquear se</p>

          <div class="suspicious-activity-inline-fields">
            <mat-form-field class="suspicious-activity-inline-field">
              <mat-label>Número de respostas</mat-label>
              <input
                matInput
                type="number"
                placeholder="Número de respostas"
                formControlName="consecutiveResponsesThreshold"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level1.controls.consecutiveResponsesThreshold.hasError('required')) {
                <mat-error>Número de respostas é obrigatório</mat-error>
              }
            </mat-form-field>

            <span class="suspicious-activity-connector">em</span>

            <mat-form-field class="suspicious-activity-inline-field">
              <mat-label>Limite de tempo (em minutos)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="observationWindowMinutes"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level1.controls.observationWindowMinutes.hasError('required')) {
                <mat-error>Limite de tempo é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="suspicious-activity-stack-field">
            <p class="suspicious-activity-helper">Exibir mensagem por</p>
            <mat-form-field>
              <mat-label>Tempo de Exibição da Mensagem (Nível 1)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="messageDisplayMinutes"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level1.controls.messageDisplayMinutes.hasError('required')) {
                <mat-error>Tempo de exibição é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="suspicious-activity-stack-field">
            <mat-form-field>
              <mat-label>Quantidade de Ocorrências</mat-label>
              <input
                matInput
                type="number"
                placeholder="Quantidade de Ocorrências"
                formControlName="level1RecurrenceThreshold"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level1.controls.level1RecurrenceThreshold.hasError('required')) {
                <mat-error>Quantidade de Ocorrências é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="suspicious-activity-block" formGroupName="level2">
        <div class="suspicious-activity-level-line">
          <mat-slide-toggle
            class="section-toggle"
            formControlName="active"
            aria-label="Ativar Nível 2 - Percentual de Acréscimo para Alerta"
          ></mat-slide-toggle>
          <h4>Nível 2 - Percentual de Acréscimo para Alerta</h4>
        </div>

        <div class="suspicious-activity-panel">
          <p class="suspicious-activity-helper">Bloquear se respostas ultrapassar o percentual</p>

          <div class="suspicious-activity-inline-fields">
            <mat-form-field class="suspicious-activity-inline-field">
              <mat-label>Percentual em relação à média (%)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Percentual em relação à média (%)"
                formControlName="alertPercentageThreshold"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level2.controls.alertPercentageThreshold.hasError('required')) {
                <mat-error>Percentual é obrigatório</mat-error>
              }
            </mat-form-field>

            <span class="suspicious-activity-connector">ou</span>

            <mat-form-field class="suspicious-activity-inline-field">
              <mat-label>Quantidade quando não houver média</mat-label>
              <input
                matInput
                type="number"
                placeholder="Quantidade"
                formControlName="quantityWhenNoAverage"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level2.controls.quantityWhenNoAverage.hasError('required')) {
                <mat-error>Quantidade é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="suspicious-activity-stack-field">
            <p class="suspicious-activity-helper">Considerar respostas dentro da janela de</p>
            <mat-form-field>
              <mat-label>Limite de tempo (em minutos)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="observationWindowMinutes"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level2.controls.observationWindowMinutes.hasError('required')) {
                <mat-error>Limite de tempo é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="suspicious-activity-stack-field">
            <p class="suspicious-activity-helper">Exibir mensagem por</p>
            <mat-form-field>
              <mat-label>Tempo de Exibição da Mensagem (Nível 2)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="messageDisplayMinutes"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level2.controls.messageDisplayMinutes.hasError('required')) {
                <mat-error>Tempo de exibição é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="suspicious-activity-stack-field">
            <mat-form-field>
              <mat-label>Quantidade de Ocorrências</mat-label>
              <input
                matInput
                type="number"
                placeholder="Quantidade de Ocorrências"
                formControlName="level2RecurrenceThreshold"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level2.controls.level2RecurrenceThreshold.hasError('required')) {
                <mat-error>Quantidade de Ocorrências é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="suspicious-activity-block" formGroupName="level3">
        <div class="suspicious-activity-level-line">
          <mat-slide-toggle
            class="section-toggle"
            formControlName="active"
            aria-label="Ativar Nível 3 - Persistência da anomalia"
            [matTooltip]="form.controls.suspiciousActivityConfig.controls.level3.controls.active.disabled ? 'Ative o Nível 1 ou o Nível 2 para liberar o Nível 3' : ''"
          ></mat-slide-toggle>
          <h4>Nível 3 - Persistência da anomalia</h4>
        </div>

        <div class="suspicious-activity-panel ">
          <p class="suspicious-activity-helper">Bloquear temporariamente por</p>

          <div class="suspicious-activity-stack-field suspicious-activity-panel--compact">
            <mat-form-field>
              <mat-label>Tempo de Bloqueio Temporário</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="blockDurationMinutes"
              />
              @if (form.controls.suspiciousActivityConfig.controls.level3.controls.blockDurationMinutes.hasError('required')) {
                <mat-error>Tempo de bloqueio é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>


      <div class="suspicious-activity-block" formGroupName="qrCode">
        <div class="suspicious-activity-level-line suspicious-activity-level-line--static">
          <h4>QR Code</h4>
        </div>

        <div class="suspicious-activity-panel">
          <p class="suspicious-activity-helper">Permitir nova pesquisa após</p>

          <div class="suspicious-activity-stack-field suspicious-activity-panel--compact">
            <mat-form-field>
              <mat-label>Limite de tempo entre pesquisas via QR Code</mat-label>
              <input
                matInput
                type="number"
                placeholder="Limite de tempo (em minutos)"
                formControlName="minVoteIntervalMinutes"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      </div>
    }

  </form>

  <div class="incentive">
    <button class="btn danger btn-icon" (click)="incentiveAdd()">
      <img class="icon" src="assets/img/incentive-trophy.png" alt="trofeu incentivo"/>
      Adicionar incentivo
    </button>
    <button class="btn danger__no-bg " (click)="incentiveHistory()">Ver historico</button>
  </div>

  <div class="update">
    <button class="btn danger__no-bg" (click)="cancel()">Cancelar</button>
    <button class="btn danger" (click)="updateUnit()">Atualizar</button>
  </div>
</div>
